const buttons = document.querySelectorAll('.accordion-button');
const items = document.querySelectorAll('.accordion-item');
const rootStyle = getComputedStyle(document.documentElement);
      
const openByIndex = (index, shouldScroll = true) => {  
  const defaultOpen = items[index];
  if (!defaultOpen) return;

  items.forEach((item) => {
    item.classList.remove('open');
    const otherContent = item.querySelector('.accordion-content');
    otherContent.style.maxHeight = null;
  });

  defaultOpen.classList.add('open');
  const content = defaultOpen.querySelector('.accordion-content');
  content.style.maxHeight = content.scrollHeight + 'px';
  
  if (shouldScroll) {
    setTimeout(() => {
      const headerHeight = parseInt(rootStyle.getPropertyValue('--header-height')) || 0;
      const top = defaultOpen.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }, 300);
  }
};